import { createAction } from 'redux-actions'

import { AddHttpErrorData } from 'types/http-error'

export const ADD_HTTP_ERROR = 'ADD_HTTP_ERROR'
export const addHttpError = createAction<AddHttpErrorData>(ADD_HTTP_ERROR)
